<template>
  <div class="com-part5">
    <title1 class="title-scale" type="1" title="运营趋势" style="margin-top: 30px" />
    <div class="p-content flex align-center flex-wrap">
      <!-- <div
                v-for="(item, i) in list"
                :key="'list' + i"
                class="item flex justify-center align-center">
                <div class="item-l flexs" :style="{'background': item.color}"></div>
                <div class="item-c flexs" :style="{'color': item.color}">{{ item.label }}</div>
                <div class="item-r flex1">
                    <dv-digital-flop style="height: 30px; width: 100%" :config="dvDigitalFlopConfig(item)" />
                </div>
            </div> -->
      <div class="flex flex-wrap boxItem align-content">
        <div
          v-for="(item, index) in target"
          :key="'target' + index"
          class="flex item align-items justify-content-evenly"
        >
          <!-- <img class="img" :src="require(`@/assets/images/computility/dispatch-icon-${item.type}.png`)" alt=""> -->
          <div>
            <img
              class="img"
              style="width: 120px; height: 120"
              :src="
                require(`@/assets/images/computility/overview-top-${
                  index + 1
                }.png`)
              "
              alt=""
            />
          </div>
          <div class="item-r flex-direction align-items">
            <!-- <div class="num">{{ item.load }}%</div> -->
            <div class="num">
              <animate-number
                from="0"
                :to="item.number"
                :key="item.number"
                duration="2000"
              ></animate-number>
            </div>
            <div class="label">{{ item.label }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyTitle from "../myTitle.vue";
import title1 from "@/views/exposition/components/title2";
import { dataInterface } from "@/api/dataInterfaceApi";
export default {
  components: {
    MyTitle,
    title1,
  },
  data() {
    return {
      target: [
        {
          number: 0,
          label: "出租率(%)",
        },
        {
          number: 0,
          label: "总充值(卡时)",
        },
        {
          number: 0,
          label: "总消耗(卡时)",
        },
        {
          number: 0,
          label: "待消耗(卡时)",
        },
      ],
    };
  },
  mounted() {
    this.getbatteryCharging();
    this.selectStationAlarmList();
    this.getbatteryCharging1();
  },
  methods: {
    // 字体动态
    dvDigitalFlopConfig(item = {}) {
      let counts = parseFloat(item.value || 0);
      let config = {
        number: [parseFloat(counts)],
        textAlign: item.textAlign || "center",
        style: {
          fill: item.color || "#fff",
          fontSize: item.fontSize || 32,
          fontFamily: "DS-Digital-Bold",
        },
      };
      console.log("==config==", config);
      return config;
    },
    getbatteryCharging() {
      let params = {
        enCode: "computingpower-mid-ylhz",
      };
      dataInterface.dataFaceApi(params).then((res) => {
        console.log(res, "预览汇总");
        if (!res) return;
        // this.target[0].number = res[0].order_total || '-'
        // this.target[1].number = res[0].user_total || '-'
        this.target[2].number = res[0].usetime_total || "-";
        this.target[3].number = res[0].unusetime_total || "-";
        this.total = res[0].time_total || "-";
      });
    },
    selectStationAlarmList(data = {}) {
      let _this = this;
      let params = {
        enCode: "computingpower-right-slzltj",
      };
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if (!res) return;
          console.log("算力租赁统计", res);
          // this.list[0].number = res[0].now_gpu_total || '-'
          // this.list[1].number = res[0].gpu_total || '-'
          this.target[0].number = res[0].now_rate || "-";
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 预览汇总
    getbatteryCharging1() {
      let params = {
        enCode: "computingpower-mid-ylhz",
      };
      dataInterface.dataFaceApi(params).then((res) => {
        console.log(res, "预览汇总");
        if (!res) return;
        // this.target[0].number = res[0].order_total || "-";
        // this.target[1].number = res[0].user_total || "-";
        // this.target[2].number = res[0].usetime_total || "-";
        // this.target[3].number = res[0].unusetime_total || "-";
        this.target[1].number = res[0].time_total || "-";
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../comm.scss";

.com-part5 {
  width: 100%;
  height: 475px;
  .sub-title {
    font-size: $FontSize20;
    padding-top: 20px;
    height: 50px;
    > div {
      padding-right: 20px;
      > p {
        text-shadow: 0px 0px 9px #03b9bd;
        padding: 0 10px;
        position: relative;
        cursor: pointer;
        &.at {
          &::after {
            position: absolute;
            bottom: -10px;
            left: 0;
            content: "";
            width: 100%;
            height: 2px;
            background: linear-gradient(
              270deg,
              rgba(113, 186, 188, 0.0001) 0%,
              #71bbbd 33.33%,
              #6db5b7 66.67%,
              rgba(111, 185, 187, 0.0001) 100%
            );
          }
        }
      }
    }
  }
  .p-content {
    width: 100%;
    height: 350px;
    .item {
      width: 50%;
      font-size: $FontSize20;
      // padding: 10px 50px;
      .item-l {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        margin-right: 10px;
      }
      .item-c {
        width: 80px;
      }
    }
  }
  .boxItem {
    width: 100%;
    height: 100%;
  }
}
.item {
  height: 140px;
  width: 200px;
  .item-r {
    margin-left: 25px;
    display: flex;
    width: 200px;
    height: 100%;
    justify-content: space-between;
    .label {
      font-size: $FontSize34;
    }
    .num {
      @include ffamily-DS;
      font-size: $FontSize60;
      color: $FontColor;
    }
  }
}
.img {
  animation: breath_light 3s ease infinite;
}
</style>